import React from 'react';

type ICustomCache = {
  cachedData: Map<string, any>;
  updateCacheWithKey: (key: string, data: any) => void;
  updateCacheWithParams: (params: any, data: any) => void;
};

export const CustomCacheContext = React.createContext<ICustomCache>({
  cachedData: new Map(),
  updateCacheWithKey: () => {},
  updateCacheWithParams: () => {}
});

export const CustomCacheProvider = ({ children }) => {
  const [cachedData, setCachedData] = React.useState(new Map());

  const updateCacheWithKey = (key, data) => {
    setCachedData((prev) => {
      const newCached = new Map(prev);
      newCached.set(key, data);
      return newCached;
    });
  };

  const updateCacheWithParams = (params, data) => {
    setCachedData((prev) => {
      const newCached = new Map(prev);
      newCached.set(JSON.stringify(params), data);
      return newCached;
    });
  };

  return (
    <CustomCacheContext.Provider
      value={{
        updateCacheWithKey,
        updateCacheWithParams,
        cachedData
      }}
    >
      {children}
    </CustomCacheContext.Provider>
  );
};
